import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { LegalTermsLink } from '../DocumentLinks';

const TRANSLATION_KEY = 'legal_documents_package.send_modal.legal_terms_disclaimer';

export const LegalTermsDisclaimer = (props: React.ComponentProps<typeof Text>) => (
    <Text size="b_xs" color="bodySecondary" {...props}>
        <I18n
            k={TRANSLATION_KEY}
            templates={{
                link: (text) => <LegalTermsLink text={text as string} />,
            }}
        />
    </Text>
);
